import { StandardRead } from "@/services/generatedApi";
import { NO_STANDARD_ID } from "@/ui-components/layouts/components/AssessmentsMenu/utils";
import { MenuItem, Select } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

type StandardSelectProps = {
  standards: StandardRead[];
  selectedStandard: string;
  // Will be string when NO_STANDARD_ID is selected
  // otherwise will be a number (standard id)
  onStandardChange: (newId: string | number) => void;
};

export const StandardSelect: React.FC<StandardSelectProps> = ({ standards, selectedStandard, onStandardChange }) => {
  const { t } = useTranslation();
  return (
    <Select
      name="standard"
      sx={{ width: "100%" }}
      value={selectedStandard}
      onChange={e => onStandardChange(e.target.value)}
      size="small"
    >
      <MenuItem value={NO_STANDARD_ID}>{t("assessments.Default_View")}</MenuItem>
      {standards!.map(standard => (
        <MenuItem value={standard.id} key={standard.id}>
          {standard.name}
        </MenuItem>
      ))}
    </Select>
  );
};
